import axios from "axios";

const baseURL = {
    development: 'https://ipdapi-dev.boomitra.com',
    production: 'https://ipdapi.boomitra.com',
    local: "http://localhost:8080/dev",
    dev1: 'https://a4l182miy6.execute-api.ap-south-1.amazonaws.com/dev-1/'
}


export default axios.create({ baseURL: baseURL[process.env.REACT_APP_ENV || 'production'] });